import {Field} from 'formik'
import {CheckboxWithLabel} from 'formik-material-ui'
import React, {Fragment, useState} from 'react'
import {Grid, Grow, IconButton, Typography} from '@material-ui/core'
import {ChevronLeftRounded, ChevronRightRounded} from '@material-ui/icons'
import {Document, Page, Outline, pdfjs} from 'react-pdf'
import {PageSwitcherContainer, TermsContainer} from './styles'
pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`

const TermsOfUse = () => {
  const [pageNumber, setPageNumber] = useState(1)
  const [pageLength, setPageLength] = useState(0)

  function changePage(offset) {
    setPageNumber(prevPageNumber => prevPageNumber + offset);
  }

  function previousPage() {
    changePage(-1);
  }

  function nextPage() {
    changePage(1);
  }
  return (
    <Fragment>
      <Grow mountOnEnter in timeout={500}>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Typography
              component="h5"
              variant="h5"
              gutterBottom
              color="textPrimary">
              Termos de uso
            </Typography>
          </Grid>
          <Grid item xs={12}>
           <TermsContainer>
             <Document
               file="/termos-uso-sistema-paralelo.pdf"
               onLoadSuccess={({numPages}) => setPageLength(numPages)}
             >
               <Page width={350} pageNumber={pageNumber} />
               <Outline />
             </Document>
           </TermsContainer>
            <PageSwitcherContainer>
              <IconButton
                disabled={pageNumber <= 1}
                onClick={previousPage}
              >
                <ChevronLeftRounded />
              </IconButton>
              <Typography
                component="p"
                variant="p"
                color="textPrimary">
                Página {pageNumber || (pageLength ? 1 : '--')} de {pageLength || '--'}
              </Typography>
              <IconButton
                disabled={pageNumber >= pageLength}
                onClick={nextPage}
              >
                <ChevronRightRounded />
              </IconButton>
            </PageSwitcherContainer>
          </Grid>
          <Grid item xs={12}>
            <Field
              Label={{ label: 'Li e estou de acordo com os Termos de Uso do Sistema Paralelo' }}
              color="primary"
              label="Li e estou de acordo com os Termos de Uso do Sistema Paralelo"
              name="termsAccepted"
              type="checkbox"
              component={CheckboxWithLabel}
            />
          </Grid>
          <Grid item xs={12}>
            <Field
              Label={{ label: 'Quero receber novidades do Sistema Paralelo por e-mail e SMS' }}
              color="primary"
              label="Quero receber novidades do Sistema Paralelo por e-mail e sms"
              name="notifyAccepted"
              type="checkbox"
              component={CheckboxWithLabel}
            />
          </Grid>
        </Grid>
      </Grow>
    </Fragment>
  );
};

export default TermsOfUse;
